(() => {
  const injectStyles = () => {
    if (document.getElementById('darxy-sticky-atc-price-css')) return;
    const style = document.createElement('style');
    style.id = 'darxy-sticky-atc-price-css';
    style.textContent =
      '.darxy-sticky-atc__price{display:inline-flex;align-items:baseline;gap:10px;white-space:nowrap;font-family:var(--darxy-mono)!important;font-size:15px;letter-spacing:0;color:#111;}' +
      '.darxy-sticky-atc__price *{font-family:var(--darxy-mono)!important;}' +
      '.darxy-sticky-atc__compare{text-decoration:line-through;color:rgba(0,0,0,.45);font-size:13px;}' +
      '.darxy-sticky-atc__compare[hidden]{display:none;}';
    document.head.appendChild(style);
  };

  const setup = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const original = document.querySelector('product-form form [name="add"], product-form [name="add"]');
    if (!original || document.querySelector('.darxy-sticky-atc')) return;
    injectStyles();

    const bar = document.createElement('div');
    bar.className = 'darxy-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');

    const price = document.createElement('span');
    price.className = 'darxy-sticky-atc__price';
    const compare = document.createElement('s');
    compare.className = 'darxy-sticky-atc__compare';
    const current = document.createElement('span');
    current.className = 'darxy-sticky-atc__current';
    price.append(compare, current);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'darxy-sticky-atc__button';

    const clean = (el) => (el ? el.textContent.trim().replace(/\s+/g, ' ') : '');
    let lastKey = '';

    const sync = () => {
      const priceBox = document.querySelector('.product__info-container .price');
      let currentText = '';
      let compareText = '';
      if (priceBox) {
        if (priceBox.classList.contains('price--on-sale')) {
          currentText = clean(priceBox.querySelector('.price__sale .price-item--sale'));
          compareText = clean(priceBox.querySelector('.price__sale .price-item--regular'));
        } else {
          currentText = clean(priceBox.querySelector('.price__regular .price-item--regular')) || clean(priceBox.querySelector('.price-item'));
        }
      }
      const label = original.textContent.trim();
      const key = currentText + '|' + compareText + '|' + label + '|' + original.disabled;
      if (key === lastKey) return;
      lastKey = key;
      current.textContent = currentText;
      compare.textContent = compareText;
      compare.hidden = !compareText;
      button.textContent = label;
      button.disabled = original.disabled;
    };

    button.addEventListener('click', () => {
      if (!button.disabled) original.click();
    });

    bar.append(price, button);
    document.body.appendChild(bar);
    sync();

    const updateVisibility = () => {
      const rect = original.getBoundingClientRect();
      const originalVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      const scrolledEnough = window.scrollY > window.innerHeight * 0.45;
      const show = scrolledEnough && !originalVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    };

    new MutationObserver(sync).observe(original, {attributes:true, childList:true, subtree:true});
    const priceWrap = document.querySelector('.product__info-container [id^="price-"]');
    if (priceWrap) new MutationObserver(sync).observe(priceWrap, {childList:true, subtree:true, characterData:true});
    document.addEventListener('change', () => setTimeout(sync, 0));
    window.addEventListener('scroll', updateVisibility, {passive:true});
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
